import axios, { AxiosResponse } from "axios";

export const paymentService = {
  initiatePayment: (policyId: number): Promise<AxiosResponse<any>> => {
    return axios.put(
      `/policy/${policyId}/pay`,
      null,
      {
        headers: { "content-type": "application/json" }
      }
    );
  }
};
